import {
    Group, Mesh, Material, MeshPhongMaterial, Geometry,
} from 'three';
import { PartsMesh } from './PartsMesh';
import { PartsMeshs } from './PartsMeshs';

const isMaterial = (mat: Material): mat is Material => mat instanceof Material;
const isMaterials = (mats: Material): mats is Material[] => Array.isArray(mats);

const getMesh = (model: Group, name: string): Mesh | null => {
    const obj = model.getObjectByName(name);
    if (obj === undefined) {
        return null;
    }

    if (!(obj instanceof Mesh)) {
        return null;
    }

    const s = obj as Mesh;
    return s;
};

export const partsMeshBuild = (
    model: Group,
    meshName: string,
    matName: string,
    enableRestore: boolean,
): PartsMesh | PartsMeshs => {
    const m = getMesh(model, meshName);
    if (m === null) {
        console.error('[partsMeshBuild] mesh not found:', meshName, matName);
        throw new Error('[partsMeshBuild] mesh not found:');
    }

    if (isMaterial(m?.material)) {
        const mat = m.material;
        if (mat.name === matName) {
            return new PartsMesh(
                m as Mesh<Geometry, MeshPhongMaterial>,
                enableRestore,
            );
        }
        console.error('[partsMeshBuild] material not found:', meshName, matName);
    } else if (isMaterials(m?.material)) {
        const mats = m.material as MeshPhongMaterial[];
        const index = mats.findIndex((mat) => mat.name === matName);
        if (index >= 0) {
            return new PartsMeshs(
                m as Mesh<Geometry, MeshPhongMaterial[]>,
                index,
                enableRestore,
            );
        }
        console.error('[partsMeshBuild] materials not found:', meshName, matName);
    }

    console.error('[partsMeshBuild] not materials:', meshName, matName);

    throw new Error('[partsMeshBuild] not materials:');
};
